import React, { FunctionComponent, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SurveyStep } from '@models/Survey/SurveyStep'
import { SurveyContext } from '@context/SurveyContext'
import { NavigationContext } from '@context/NavigationContext'
import { TabbedPane } from '@components/Survey/TabbedPane/TabbedPane'
import './EmailPage.scss'
import { usePreventBackNavigation } from '@hooks/usePreventBackNavigation'

export function EmailPage() {
  usePreventBackNavigation()
  const { t } = useTranslation('Email')
  const { setPrevHandler, setNextHandler } = useContext(NavigationContext)
  const { submitEmail, setNextStep } = useContext(SurveyContext)
  const [email, setEmail] = useState('')

  const navigateToAcknowledge = () => {
    if (email) {
      submitEmail(email)
    }
    setNextStep(SurveyStep.Acknowledge)
  }

  useEffect(() => {
    setPrevHandler(undefined)
    setNextHandler(navigateToAcknowledge)

    return () => {
      setPrevHandler(undefined)
      setNextHandler(undefined)
    }
  }, [email])

  const tabs = [
    {
      text: t('navigation.title'),
    },
  ]
  return (
    <TabbedPane tabs={tabs} contentText={t('questionText')} propClassName="Email">
      <div key="bd" className="body">
        <div className="form-control">
          <input type="email" placeholder={t('placeholder')} value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <p>{t('detailsText')}</p>
      </div>
    </TabbedPane>
  )
}

export default EmailPage
